var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiltered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#0078E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5942 6H6.28659C5.79819 6 5.40039 6.3978 5.40039 6.8862V9.198C5.40039 9.6666 5.60739 10.1076 5.93619 10.3782L9.86739 14.2224V17.5242C9.86739 17.8254 10.012 18.1116 10.255 18.2904C10.42 18.4122 10.6192 18.4758 10.8202 18.4758C10.9144 18.4758 11.0086 18.462 11.101 18.4338L13.345 17.739C13.7452 17.6148 14.0146 17.25 14.0146 16.83V14.223L17.9134 10.4082C18.2746 10.1082 18.481 9.6678 18.481 9.1986V6.8862C18.4804 6.3978 18.0826 6 17.5942 6ZM17.4004 9.198C17.4004 9.345 17.3362 9.483 17.1904 9.606L13.0966 13.6086C12.9922 13.71 12.934 13.8492 12.934 13.995V16.7346L10.9474 17.3496V13.995C10.9474 13.8498 10.8886 13.7106 10.7848 13.6086L6.65859 9.5766C6.54519 9.483 6.48039 9.345 6.48039 9.198V7.08H17.4004V9.198Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltered);
export default __webpack_public_path__ + "static/media/filtered.0fb347fd87ebf02f24a8c16bbcc87883.svg";
export { ForwardRef as ReactComponent };